import globalMU from "globalMU";
import { DadosFreteProduto, TipoFreteDisponivel } from "./tipos";

export function obterChaveSelecaoTipoFrete(tipoFrete: TipoFreteDisponivel) {
    return  tipoFrete == null || tipoFrete.Id == 0 || tipoFrete.Id == null ? "" :
            tipoFrete.Id + '-' + (tipoFrete.EhFreteEspecial ? "ESPECIAL" : "NORMAL")
}

export function obterChaveSelecaoTipoFretePelosDadosProduto(dados: DadosFreteProduto) {
    return  (dados?.idTipoFrete ?? 0) == 0 ? "" :
            dados.idTipoFrete + '-' + (dados.ehFreteEspecial ? "ESPECIAL" : "NORMAL")
}

export function obterTipoFrete(chave:string, tiposFrete:TipoFreteDisponivel[]) {
    return  globalMU.isNullOrEmpty(chave) ? null :
            tiposFrete.find(tf => obterChaveSelecaoTipoFrete(tf) == chave)
}

export function obterIdTipoFreteSelecionado(chave:string) {
    return Number(chave.substring(0, chave.lastIndexOf("-")))
}

export function chaveEhDeFreteEspecial(chave:string) : boolean {
    return (chave ?? "").includes("ESPECIAL")
}